import { styled } from '@mui/material/styles';
import { Stack, Typography, Autocomplete } from '@mui/material';

export const StyledMainStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
  paddingLeft: theme.spacing(13),
  paddingRight: theme.spacing(13),
  paddingTop: theme.spacing(3),
}));

export const TitleTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'component'
})<{ component?: string }>({
  fontWeight: '500',
});

export const subtitleStyles = {
  color: 'inherit',
};

export const StyledAutocomplete = styled(Autocomplete)({
  backgroundColor: 'white',
  borderRadius: '40px',
});

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  ...subtitleStyles,
  color: theme.palette.text.secondary
})); 